module.exports = __webpack_public_path__ + "static/media/MasterCard.5b73e641.svg";